import Component from '../core/Component'
import {EMITS as SLIDER_EMITS} from './Slider'

export default class Responsibility extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null,
            indicator: null,
            links: [],
            menu: null
        }

        this.index = null
    }

    prepare() {
        this.slider = Component.getFromElement(this.ref.slider)
        this.slider.on(SLIDER_EMITS.SELECTED, this.handleSliderSelected)

        this.menu = Component.getFromElement(this.ref.menu)

        this.ref.links.forEach(link => link.addEventListener('click', this.handleLinkClick))
    }

    handleSliderSelected = data => {
        this.index = data.index
        if (this.menu) {
            this.menu.select(this.index)
        }
        this.update()
    }

    handleLinkClick = event => {
        event.preventDefault()

        const element = event.currentTarget
        const index = this.ref.links.findIndex(link => link === element)
        this.index = index

        if (!~index) {
            return
        }

        this.slider.select(index)
        this.update()
    }

    update() {
        this.ref.links.forEach(link => link.classList.remove('is-active'))
        this.ref.links[this.index].classList.add('is-active')
        this.updateIndicator()
    }

    updateIndicator() {
        const currentLink = this.ref.links[this.index]
        const width = currentLink.offsetWidth
        const left = currentLink.offsetLeft

        this.ref.indicator.style.width = `${width}px`
        this.ref.indicator.style.transform = `translate3d(${left}px,0,0)`
    }



}